import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  ViewEncapsulation,
} from "@angular/core";
import { Subscription } from "rxjs";

import { LocalizeService } from "../../insa-services";
import { ControlTableService } from "./control-table.service";
import { ControlTable } from "./control-table.models";

@Component({
  selector: "app-control-table-admin",
  templateUrl: "./control-table-admin.component.html",
  styles: [require("./control-table.component.css").toString()],
  encapsulation: ViewEncapsulation.None,
})
export class ControlTableAdminComponent implements OnInit, OnDestroy {
  tables: ControlTable[] = [];
  newTableName = "";

  editingId: string | null = null;
  editingName = "";

  confirmDeleteId: string | null = null;

  private sub: Subscription;

  constructor(
    private _localize: LocalizeService,
    private _element: ElementRef,
    private _service: ControlTableService,
  ) {}

  ngOnInit(): void {
    this.sub = this._service.tables.subscribe((tables) => {
      this.tables = tables;
      this.reapplyLocalize();
    });
  }

  ngOnDestroy(): void {
    if (this.sub) this.sub.unsubscribe();
  }

  createTable(): void {
    const name = this.newTableName.trim();
    if (!name) return;
    this._service.createTable(name);
    this.newTableName = "";
  }

  startRename(table: ControlTable): void {
    this.editingId = table.id;
    this.editingName = table.name;
  }

  cancelRename(): void {
    this.editingId = null;
    this.editingName = "";
  }

  saveRename(): void {
    if (!this.editingId) return;
    const name = this.editingName.trim();
    if (name) this._service.renameTable(this.editingId, name);
    this.cancelRename();
  }

  askDelete(table: ControlTable): void {
    this.confirmDeleteId = table.id;
  }

  cancelDelete(): void {
    this.confirmDeleteId = null;
  }

  confirmDelete(): void {
    if (this.confirmDeleteId) this._service.deleteTable(this.confirmDeleteId);
    this.confirmDeleteId = null;
  }

  rowCount(table: ControlTable): number {
    return table.rows ? table.rows.length : 0;
  }

  private reapplyLocalize(): void {
    setTimeout(
      () => this._localize.applyTranslations(this._element.nativeElement),
      0,
    );
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-control-table/control-table-admin.component.ts